var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledFeedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7701 12.4C14.9201 12.47 15.0901 12.5 15.2501 12.5C15.5801 12.5 15.8901 12.37 16.1301 12.14L18.3101 10H19.2501C20.7701 10 22.0001 8.77 22.0001 7.25V4.75C22.0001 3.23 20.7701 2 19.2501 2H14.7501C13.2301 2 12.0001 3.23 12.0001 4.75V7.25C12.0001 8.51 12.8501 9.57 14.0001 9.9V11.25C14.0001 11.75 14.3101 12.2 14.7701 12.4ZM8.0001 13.5C6.0701 13.5 4.5001 11.93 4.5001 10C4.5001 8.07 6.0701 6.5 8.0001 6.5C9.9301 6.5 11.5001 8.07 11.5001 10C11.5001 11.93 9.9301 13.5 8.0001 13.5ZM8.0001 22C5.9401 22 4.3601 21.44 3.3001 20.33C1.9641 18.926 1.9971 17.156 2.0001 16.973V16.96C2.0001 15.89 2.9001 15 4.0001 15H12.0001C13.1001 15 14.0001 15.9 14.0001 17L14.0011 17.006C14.0041 17.133 14.0461 18.916 12.7011 20.33C11.6401 21.44 10.0601 22 8.0001 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledFeedIcon);
export default __webpack_public_path__ + "static/media/FilledFeedIcon.c0a5e41a2d4ee7d697bdb5f0efd392a5.svg";
export { ForwardRef as ReactComponent };